import React, { useEffect } from 'react';

const SimpleModal = ({ children, modalName, closeSetter }) => {

    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                closeSetter(prevState => ({
                    ...prevState,
                    [modalName]: false
                }));
            }
        };

        // Add event listener when the component mounts
        document.addEventListener('keydown', handleEscKey);

        // Clean up the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [modalName, closeSetter]);

    return <div className={'modal'}>
        <div className={'simpleModalContent'}>
            <button className={`btn btnDanger btnClose`} onClick={e => closeSetter(prevState => ({
                ...prevState,
                [modalName]: false
            }))}>x</button>
            {children}
        </div>
    </div>
}

export default SimpleModal